/** "Oct 21" for a team deadline (RFC 3339), or null when missing or invalid. */
export function formatTeamDeadline(iso: string | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
